<template>
  <div>
    <Head> </Head>
    <div class="index">
      <Leftside style="flex:1" :isActive='isActive' @leftnav='nav'></Leftside>
      <div class="content" style="flex:5">
          <!-- 导航标签 -->
          <mainnav :navActive='navActive'></mainnav>
          <!-- 轮播 -->
          <!--<el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="item in 2" :key="item" :autoplay="false">
              <img src="../assets/nav_1.png" style="width:100%;height:100%;margin: 20px 0 25px;">
            </el-carousel-item>
          </el-carousel>-->
          

          <!-- 发现失信人 -->
          <Assignment1 v-if="data == 1" @son='step'></Assignment1>
          <Assignment2 v-else-if="data == 2" @son='step'></Assignment2>
          <Assignment3 v-else-if="data == 3" @son='step'></Assignment3>
          <Assignment4 v-else-if="data == 4" @son='step'></Assignment4>
          <Assignment5 v-else @son='step'></Assignment5>


      </div>
    </div>
  </div>
</template>

<script>
import Head from '../common/head.vue'
import Leftside from '../common/leftside.vue'
import mainnav from '../common/main_nav.vue'
import Assignment1 from '../common/Assignment1.vue'
import Assignment2 from '../common/Assignment2.vue'
import Assignment3 from '../common/Assignment3.vue'
import Assignment4 from '../common/Assignment4.vue'
import Assignment5 from '../common/Assignment5.vue'
export default {
  name: 'Assignment',
  data () {
    return {
      isActive:'0',
      navActive:'2',
      data:'1',
    }
  },
  mounted(){
    
    
  },
  methods:{
    step(data){
      this.data = data;
    },
    nav(data){
      // this.isActive = data;
      console.log(data);
    },
    tiaozhuan(url){
      this.$router.push({path:url})
    }


  },
  components:{
    Head,
    Leftside,
    mainnav,
    Assignment1,
    Assignment2,
    Assignment3,
    Assignment4,
    Assignment5
  },
}
</script>
<style scoped>
.index{
  width:100vw;
  display:flex;
}
.index .content{
  padding: 3% 2%;
  background:#f1f5f8;
}
.index .content .content_nav{
  overflow:hidden;
  background:#ffffff;
}
.index .content .content_nav li{
  float:left;
  box-sizing: border-box;
  height:80px;
  line-height:75px;
  text-align:center;
  width:20%;
  cursor: pointer;
}
.index .content .content_nav li:hover span{
  color: #2fb8c2;
  display: inline-block;
  width:50%;
  border-bottom: 5px solid #2fb8c2;
}
.index .content .content_nav li span.nav_active{
  color: #2fb8c2;
  display: inline-block;
  width:50%;
  border-bottom: 5px solid #2fb8c2;
}



</style>



// WEBPACK FOOTER //
// src/page/Assignment.vue